import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

const shots = [
  { src: "https://images.pexels.com/photos/18503604/pexels-photo-18503604.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=600", cap: "Skin Fades" },
  { src: "https://images.unsplash.com/photo-1657105052497-f996284ffff8?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", cap: "Scissor Work" },
  { src: "https://images.unsplash.com/photo-1593702275687-f8b402bf1fb5?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", cap: "Razor Line-Ups" },
  { src: "https://images.pexels.com/photos/9315046/pexels-photo-9315046.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=600", cap: "Hot Towel Shaves" },
  { src: "https://images.unsplash.com/photo-1647140655214-e4a2d914971f?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", cap: "Classic Cuts" },
  { src: "https://images.pexels.com/photos/34702982/pexels-photo-34702982.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=600", cap: "Fresh Necklines" },
];

export const Gallery = ({ onBook }) => {
  return (
    <section id="work" className="relative py-24 sm:py-32 bg-barber-bg radial-amber overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <p className="uppercase tracking-[0.35em] text-barber-amber text-xs mb-4">The Work</p>
            <h2 className="font-heading text-4xl sm:text-5xl font-bold text-barber-cream tracking-tight">
              Straight From The Chair
            </h2>
          </div>
          <p className="text-barber-muted max-w-md leading-relaxed">
            Real cuts, real clients. A look at the fades, line-ups and shaves that keep Worcester
            coming back to the chair.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {shots.map((s, i) => (
            <motion.figure
              key={i}
              data-testid={`gallery-shot-${i}`}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.1 }}
              className="group relative overflow-hidden border border-barber-gold/15"
            >
              <img
                src={s.src}
                alt={s.cap}
                loading="lazy"
                className="w-full aspect-[4/5] object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
              <figcaption className="absolute bottom-0 left-0 p-5">
                <span className="block h-0.5 w-8 bg-barber-amber mb-2 transition-all duration-300 group-hover:w-14" />
                <span className="font-heading text-lg text-barber-cream">{s.cap}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <div className="mt-14 text-center">
          <Button
            data-testid="gallery-book-btn"
            onClick={onBook}
            className="btn-gold rounded-none font-semibold px-10 py-6 tracking-wide"
          >
            Book Your Cut
          </Button>
        </div>
      </div>
    </section>
  );
};
